import { useQuery } from "@apollo/client";

import GET_CONNECTED_USER from '@graphql/getConnectedUser.graphql';

const useGetConnectedUser = (skip) => {
  const { data, ...rest } = useQuery(GET_CONNECTED_USER, { skip });
  return { connectedUser: data?.getMe, ...rest }
}

export default useGetConnectedUser;
